import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PackageList, updateInfoType, shareDeviceStatus } from '../../shareModel';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  BatteryReplacement,
  BtyReplacementParams
} from '../../my-features/battery-replacement/battery-replacement.model';
import * as fromMyfeatures from '../../my-features';
import { PreferenceService } from '../../services/preference.service';
import { DialogComponent } from '../../dialog/dialog.component';
import { isODM } from '../../../environments/environment';
import { ObjectSharingParam } from 'src/app/my-features/object-sharing/object-sharing.model';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { User } from '../../models/user';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-devcie-sharing',
  templateUrl: './devcie-sharing.component.html',
  styleUrls: ['./devcie-sharing.component.css']
})
export class DevcieSharingComponent implements OnInit, OnDestroy {
  powerMaster = isODM;
  BRBDexpireNotify = false;
  @Input() selectedView;
  deviceList$: Observable<any>;
  deviceSharingList$: Observable<any>;
  loading = true;
  private componentDestroyed = new Subject();
  groupFeature: Boolean;
  batteryReplacementInfo: BatteryReplacement;
  acode: number;
  acodeList: number[] = [];
  currentUser: any;
  userNameFlag = false;
  isMsp = false;

  displayShareListDialog = false;
  displayShareGroupListDialog = false;
  sharedDeviceName: any;
  sharedGroupName: string;
  sharedDeviceImg: any;
  selectedNode: any;
  selectedGroupNode: any;

  shareDeviceFeature: Boolean;
  dialogSaveDirty = false;
  shareDeviceListInput = '';
  shareDeviceList = [];
  shareGroupListInput = '';
  shareGroupList = [];
  displayConfirmRemoveDialog = false;
  displayConfirmShareDialog = false;
  displayConfirmDeleteDialog = false;
  displayConfirmRemoveGroupDialog = false;
  displayConfirmShareGroupDialog = false;
  displayConfirmDeleteGroupDialog = false;
  sharedUserName: any;
  objectSharingAddParam: ObjectSharingParam = {
    objectId: 0,
    owner_acode: 0
  };
  objectSharingEditParam: ObjectSharingParam = {
    objectId: 0,
    owner_acode: 0
  };
  UpdateInfoParam = {} as UpdateInfoModel;
  readSharingParam = {owner_acode: 0, shared_acode: 0, RegionIds: null};
  dataLoading = true;
  dataLoadingView = [{}, {}, {}, {}, {}];
  mspRegionFilter;
  selectedLang = '';

  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  constructor(private store: Store<fromStore.State>, private messageService: MessageService, private preferenceService: PreferenceService,
              private ngxService: NgxUiLoaderService, private translateService: TranslateService) {

                this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
                  this.acodeList.push(res.acode);
                  this.patchReadSharingParam({
                    owner_acode: res.acode,
                    shared_acode: res.acode,
                  });
                  this.acode = res.acode;
                  this.currentUser = res.currentUser;
                  // this.store.dispatch(new fromMyfeatures.GetDeviceSharingList(this.readSharingParam));
                  // this.store.dispatch(new fromMyfeatures.GetGroupSharingList(this.readSharingParam));
                });

                // this.store.dispatch(new fromStore.GetDeviceInfoAction());
                this.deviceList$ = this.store.select(fromStore.GetObjectShareToOtherList);
                this.deviceSharingList$ = this.store.select(fromStore.GetObjectShareFromOtherList);

                this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
                  // Share Device
                  if (res.type === updateInfoType.AddDeviceSharingInfo ||
                      res.type === updateInfoType.UpdateDeviceSharingInfo || res.type === updateInfoType.DeleteDeviceSharingInfo) {
                    if (!res.isLoading && res.isLoaded) {
                      if (res.isSaved) {
                        this.messageService.add({ severity: 'success', summary: 'Update Success' });
                        this.store.dispatch(new fromMyfeatures.GetDeviceSharingList({ ...this.readSharingParam }));
                        const UserParam = {regionIds: this.mspRegionFilter} as User;
                        this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
                      } else if (!res.isSaved) {
                        this.messageService.add({ severity: 'error', summary: 'Update Fail' });
                      }
                      this.ngxService.stop();
                    }
                    this.resetUpdateInfoState();
                  }
                  // Share Group
                  if (res.type === updateInfoType.AddGroupSharingInfo ||
                    res.type === updateInfoType.UpdateGroupSharingInfo || res.type === updateInfoType.DeleteGroupSharingInfo) {
                    if (!res.isLoading && res.isLoaded) {
                      if (res.isSaved) {
                        this.messageService.add({ severity: 'success', summary: 'Update Success' });
                        this.store.dispatch(new fromMyfeatures.GetGroupSharingList({ ...this.readSharingParam }));
                        const UserParam = {regionIds: this.mspRegionFilter} as User;
                        this.store.dispatch(new fromStore.GetDevicesStatusAction(UserParam));
                        const param = { regionIds : this.mspRegionFilter };
                        this.store.dispatch(new fromStore.GetGroups(param));
                        this.store.dispatch(new fromStore.GetDeviceInfoAction(param));
                      } else if (!res.isSaved) {
                        this.messageService.add({ severity: 'error', summary: 'Update Fail' });
                      }
                      this.ngxService.stop();
                    }
                    this.resetUpdateInfoState();
                  }
                });
                if (!this.powerMaster) {
                  this.store.dispatch(new fromMyfeatures.GetPlanSettings());
                }
                this.store.select(fromStore.getPlanSetting).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
                  if (res.Loaded) {
                    let purchasingPlanList = Object.values(res.entities).filter((i) => i.Status !== 2); // no expired.
                    purchasingPlanList = purchasingPlanList.map((item) => {
                      return {...item, expirationDate:
                        (item.RemainDay > 0) ? new Date().setDate(new Date().getDate() + item.RemainDay) : 'Expired'};
                    });
                  }
                });

    this.store.select(fromStore.getIsActiveUserModule, PackageList.ShareDevice).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      const packageShareDevice = Boolean(res);
      this.shareDeviceFeature = !packageShareDevice;
    });

    // Get isMsp
    this.store.select(fromStore.getIsMsp).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null) {
        this.isMsp = res;
      }
    });

    this.store.select(fromStore.getMspRegionFilter).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.mspRegionFilter = null;
      if (res !== null && res !== undefined && res.filterLoaded) {
        this.isMsp = res.isMsp;
        if (this.isMsp) {
          this.mspRegionFilter = res.selectedId;
          this.patchReadSharingParam({ RegionIds: res.selectedId });
        }
      }
    });
    
    this.translateService.onLangChange
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe((event) => {
      this.selectedLang = event.lang;
    })
  }


  ngOnInit() {
    this.packageSetting();
  }

  onLoad() {
    this.loading = false;
  }

  packageSetting() {
    this.dataLoading = true;
    setTimeout(() => {
      this.dataLoading = false;
    }, 1000);
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  errorHandler(event) {
    event.target.classList.add('defaultImg');
    event.target.src = '/assets/images/default_device.png';
  }

  alertShareDeviceDialog() {
    if (!this.isMsp) {
      this.childDialog.alertShareDevice();
    }
  }

  addShareList(rowData) {
    this.userNameFlag = false;
    this.patchObjectSharingAddParam({
      objectId: rowData.ObjectId,
      owner_acode: this.acode,
      RegionId: rowData.regionId,
    });
    this.sharedDeviceName = rowData.ObjectName;
    this.shareDeviceListInput = '';
    this.shareDeviceList = rowData.ObjectShareList;
    this.displayShareListDialog = true;
  }

  addShareGroupList(rowData) {
    this.userNameFlag = false;
    this.patchObjectSharingAddParam({
      objectId: rowData.ObjectId,
      owner_acode: this.acode,
    });
    this.sharedGroupName = rowData.ObjectName;
    this.shareGroupListInput = '';
    this.shareGroupList = rowData.ObjectShareList;
    this.displayShareGroupListDialog = true;
  }

  comfirmShareList() {
    const RejectedCount = this.shareDeviceList.filter(e => e.status === shareDeviceStatus['Rejected']);
    const ValidCount = this.shareDeviceList.length - RejectedCount.length;
    const WaitingAcceptUser = this.shareDeviceList.find(e =>
      e.SharedAccount === this.shareDeviceListInput && e.status !== shareDeviceStatus['Rejected']);

    if (ValidCount >= 3) {
      this.displayShareListDialog = false;
      this.childDialog.dialogType.ShareDeviceLimit = true;
      return;
    } else if (WaitingAcceptUser) { /// 驗證email是否與現有重複(不含Rejected)
      // 若Share User Name重複
      this.displayShareListDialog = false;
      this.childDialog.dialogType.ShareUserNameLimit = true;
    } else if (this.shareDeviceListInput.toLowerCase() === this.currentUser.toLowerCase()) {
      this.userNameFlag = true;
      return;
    } else {
      this.patchObjectSharingAddParam({ shared_user: this.shareDeviceListInput });
      this.displayConfirmShareDialog = true;
      this.displayShareListDialog = false;
    }
  }

  comfirmShareGroupList() {
    const RejectedCount = this.shareGroupList.filter(e => e.status === shareDeviceStatus['Rejected']);
    const ValidCount = this.shareGroupList.length - RejectedCount.length;
    const WaitingAcceptUser = this.shareGroupList.find(e =>
      e.SharedAccount === this.shareGroupListInput && e.status !== shareDeviceStatus['Rejected']);

    if (ValidCount >= 3) {
      this.displayShareGroupListDialog = false;
      this.childDialog.dialogType.ShareGroupLimit = true;
      return;
    } else if (WaitingAcceptUser) { /// 驗證email是否與現有重複(不含Rejected)
      // 若Share User Name重複
      this.displayShareGroupListDialog = false;
      this.childDialog.dialogType.ShareUserNameLimit = true;
    } else if (this.shareGroupListInput.toLowerCase() === this.currentUser.toLowerCase()) {
      this.userNameFlag = true;
      return;
    } else {
      this.patchObjectSharingAddParam({ shared_user: this.shareGroupListInput });
      this.displayConfirmShareGroupDialog = true;
      this.displayShareGroupListDialog = false;
    }
  }

  saveShareList() {
    // 設備分享帳號
    this.store.dispatch(new fromMyfeatures.AddDeviceSharing({ ...this.objectSharingAddParam }));
    this.displayConfirmShareDialog = false;
  }

  saveShareGroupList() {
    // group分享帳號
    this.store.dispatch(new fromMyfeatures.AddGroupSharing({ ...this.objectSharingAddParam }));
    this.displayConfirmShareGroupDialog = false;
  }

  confirmRemoveShareList(rowData) {
    this.patchObjectSharingEditParam({
      share_id: rowData.Id,
      owner_acode: rowData.owner_acode,
      objectId: null,
    });
    this.sharedUserName = rowData.SharedAccount;
    this.displayShareListDialog = false;
    this.displayConfirmRemoveDialog = true;
  }

  confirmRemoveShareGroupList(rowData) {
    this.patchObjectSharingEditParam({
      share_id: rowData.Id,
      owner_acode: rowData.owner_acode,
      objectId: null,
    });
    this.sharedUserName = rowData.SharedAccount;
    this.displayShareGroupListDialog = false;
    this.displayConfirmRemoveGroupDialog = true;
  }

  removeShareList() {
    // 刪除選取的設備分享帳號
    this.store.dispatch(new fromMyfeatures.DeleteDeviceSharing({ ...this.objectSharingEditParam }));
    this.displayConfirmRemoveDialog = false;
  }

  removeShareGroupList() {
    // 刪除選取的設備分享帳號
    this.store.dispatch(new fromMyfeatures.DeleteGroupSharing({ ...this.objectSharingEditParam }));
    this.displayConfirmRemoveGroupDialog = false;
  }

  confirmDeleteSharedDevice(rowData) {
    this.patchObjectSharingEditParam({
      share_id: rowData.Id,
      owner_acode: rowData.owner_acode,
      objectId: null,
    });
    this.displayConfirmDeleteDialog = true;
  }

  confirmDeleteSharedGroup(rowData) {
    this.patchObjectSharingEditParam({
      share_id: rowData.Id,
      owner_acode: rowData.owner_acode,
      objectId: null,
    });
    this.displayConfirmDeleteGroupDialog = true;
  }


  deleteSharedDevice() {
    // 刪除選取的設備
    this.store.dispatch(new fromMyfeatures.DeleteDeviceSharing({ ...this.objectSharingEditParam }));
    this.displayConfirmDeleteDialog = false;
  }

  deleteSharedGroup() {
    // 刪除選取的group
    this.store.dispatch(new fromMyfeatures.DeleteGroupSharing({ ...this.objectSharingEditParam }));
    this.displayConfirmDeleteGroupDialog = false;
  }

  rejectSharedDevice(rowData) {
    this.patchObjectSharingEditParam({
      share_id: rowData.Id,
      owner_acode: rowData.owner_acode,
      is_confirm: false,
    });
    this.store.dispatch(new fromMyfeatures.UpdateDeviceSharing({ ...this.objectSharingEditParam }));
  }

  rejectSharedGroup(rowData) {
    this.patchObjectSharingEditParam({
      share_id: rowData.Id,
      owner_acode: rowData.owner_acode,
      is_confirm: false,
    });
    this.store.dispatch(new fromMyfeatures.UpdateGroupSharing({ ...this.objectSharingEditParam }));
  }

  acceptSharedDvice(rowData) {
    this.patchObjectSharingEditParam({
      share_id: rowData.Id,
      owner_acode: rowData.owner_acode,
      is_confirm: true,
    });
    this.store.dispatch(new fromMyfeatures.UpdateDeviceSharing({ ...this.objectSharingEditParam }));
  }

  acceptSharedGroup(rowData) {
    this.patchObjectSharingEditParam({
      share_id: rowData.Id,
      owner_acode: rowData.owner_acode,
      is_confirm: true,
    });
    this.store.dispatch(new fromMyfeatures.UpdateGroupSharing({ ...this.objectSharingEditParam }));
  }

  displayExpiredDialog(rowData) {
    this.childDialog.expiredDialog(rowData);
  }

  displayisTrialDialog(rowData) {
    this.childDialog.isTrialDialog(rowData);
  }

  displayShareDeviceAlertDialog(rowData) {
    if (rowData.isExpired) {
      this.childDialog.alertExpiredShareDevice();
    } else if (!rowData.isExpired && !rowData.planActivate) {
      this.childDialog.alertTrialShareDevice();
    }
  }

  onPageloading(event) {
    this.dataLoading = true;
    setTimeout(() => {
      this.dataLoading = false;
    }, 1000);
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromMyfeatures.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  private patchReadSharingParam(patch: Partial<typeof this.readSharingParam>): void {
    this.readSharingParam = { ...this.readSharingParam, ...patch };
  }

  private patchObjectSharingAddParam(patch: Partial<ObjectSharingParam>): void {
    this.objectSharingAddParam = { ...this.objectSharingAddParam, ...patch };
  }

  private patchObjectSharingEditParam(patch: Partial<ObjectSharingParam>): void {
    this.objectSharingEditParam = { ...this.objectSharingEditParam, ...patch };
  }

}
